'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var ALL_AU_WHERE = 'All Australia';
exports.ALL_AU_WHERE = ALL_AU_WHERE;
var ALL_NZ_WHERE = 'All New Zealand';

exports.ALL_NZ_WHERE = ALL_NZ_WHERE;
var INDEX_UPTO_PAGE = 5;

exports.INDEX_UPTO_PAGE = INDEX_UPTO_PAGE;
var SEARCH_PARAMS = {
  keywords: true,
  classification: true,
  subclassification: true,
  where: true,
  daterange: true,
  worktype: true,
  sortmode: true,
  salarytype: true,
  salaryrange: true,
  companyid: true,
  page: true,
  savedsearchid: true,
  graduatesearch: true,
  nation: true,
  location: true,
  area: true,
  areaid: true,
  state: true,
  advertiserid: true,
  advertisergroup: true,
  isareaunspecified: true
};
exports.SEARCH_PARAMS = SEARCH_PARAMS;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/constants.js
 ** module id = 522
 ** module chunks = 0
 **/